import thumbnail from './donut_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.donutchart.title',
  id: 'donutchart',
  thumbnail,
  icon: 'fa-circle-dot',
  categories: ['categories.proportions'],
  description: 'global.section.chartselection.donutchart.description',
  code: '',
  tutorial: '',
};
